import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAppDispatch } from '../../hooks/redux';
import { toggleAvailability } from '../../store/slices/userSlice';
import toast from 'react-hot-toast';

interface AvailabilityToggleProps {
  isAvailable: boolean;
  userId: string;
  disabled?: boolean;
  textClasses: string;
  showStatus: boolean;
  size?: 'sm' | 'md';
  textSide?: 'left' | 'right';
}

const AvailabilityToggle: React.FC<AvailabilityToggleProps> = ({ 
  isAvailable, 
  userId, 
  disabled = false, 
  textClasses,
  showStatus,
  size = 'md',
  textSide = 'right'
}) => {
  const [isToggling, setIsToggling] = useState(false);
  const dispatch = useAppDispatch();

  const handleToggle = async () => {
    // console.log("cccc")
    if (disabled || isToggling) return;

    setIsToggling(true);
    try {
      var response = await dispatch(toggleAvailability(userId));
      // toast.success(`Availability ${response ? 'enabled' : 'disabled'}`);
    //   disabled = !disabled
    } catch (error) {
        // console.log(error)
      toast.error('Failed to update availability');
    } finally {
      setIsToggling(false);
    }
  };

  const buttonSizeClasses = size === 'sm' ? 'h-5 w-9' : 'h-6 w-11';
  const knobSizeClasses = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  const translateValue = size === 'sm' ? 18 : 24;
  const translateStart = size === 'sm' ? 2 : 4;

  const StatusText = () => (
    <span className={`text-sm font-medium ${
      isAvailable ? 'text-green-600' : 'text-gray-500'
    }`}>
      {isAvailable ? 'Available' : 'Busy'}
    </span>
  );

  return (
    <div className="flex items-center space-x-3">
      <span className={textClasses}>Available for work</span>
      
      {showStatus && textSide === 'left' && <StatusText />}
      
      <button
        onClick={handleToggle}
        disabled={disabled || isToggling}
        className={`relative inline-flex ${buttonSizeClasses} items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
          isAvailable ? 'bg-primary-500' : 'bg-gray-200'
        } ${disabled || isToggling ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <motion.span
          layout
          className={`inline-block ${knobSizeClasses} transform rounded-full bg-white shadow transition-transform ${
            isAvailable ? `translate-x-[${translateValue}px]` : `translate-x-[${translateStart}px]`
          }`}
          animate={{
            x: isAvailable ? translateValue : translateStart,
          }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        />
        {isToggling && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
      </button>
      
      {showStatus && textSide === 'right' && <StatusText />}
    </div>
  );
};

export default AvailabilityToggle;
